'use strict';

$(() => {
    $('#contactUsForm').on('submit', (e) => {
        $('.invalid-feedback').hide();
        let recaptcha = $('#g-recaptcha-response').val();
        if (recaptcha === '') {
            $('.invalid-feedback-captcha').show();
            e.preventDefault();
        }
    });
});
